import BaseRepository from '@/baseRepository/BaseRepository';
const resource = `/api/v1/activitytypes`;

export default {
  getActvieType(baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${resource}`, {
      baseURL,
      headers,
      params,
    });
  },
};
